import { Stepper, label } from "./ui";

function Row({ title, hint, children }) {
    return (
        <div className="flex items-center justify-between gap-4 rounded-2xl border border-ink/10 p-4">
            <span className="text-sm"><strong>{title}</strong>{hint && <span className="block text-xs text-dim">{hint}</span>}</span>
            {children}
        </div>
    );
}

export function ParticipantsPicker({ tour, value, onChange, maxAvailable }) {
    const total = value.adults + value.children_paid + value.children_free;
    const cap = Math.min(tour.max_guests || 10, maxAvailable ?? 99);
    const room = cap - total;
    const set = (k) => (n) => onChange({ ...value, [k]: n });
    const childAge = tour.child_discount_max_age ? `até ${tour.child_discount_max_age} anos` : "";
    return (
        <div data-testid="participants-picker">
            <span className={label}>Participantes</span>
            <div className="space-y-2">
                <Row title="Adultos" hint="Inclui o responsável (maior de 18 anos)">
                    <Stepper title="adulto" testid="guests-adults" value={value.adults} min={1} max={value.adults + room} onChange={set("adults")} />
                </Row>
                {tour.allow_children !== false && (
                    <Row title="Crianças" hint={[childAge, tour.child_price != null ? "tarifa reduzida" : "tarifa integral"].filter(Boolean).join(" · ")}>
                        <Stepper title="criança" testid="guests-children" value={value.children_paid} max={value.children_paid + room} onChange={set("children_paid")} />
                    </Row>
                )}
                {tour.allow_children !== false && tour.child_free_max_age != null && (
                    <Row title="Crianças com gratuidade" hint={`até ${tour.child_free_max_age} anos`}>
                        <Stepper title="criança gratuita" testid="guests-free" value={value.children_free} max={value.children_free + room} onChange={set("children_free")} />
                    </Row>
                )}
            </div>
            <p className="mt-2 text-xs text-dim">
                Máximo de {cap} participante(s){tour.min_age ? ` · idade mínima ${tour.min_age} anos` : ""}. A participação depende das regras de segurança e documentação exigidas.
            </p>
        </div>
    );
}
